import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { reducer } from './state/agent.reducer';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { AgentEffects } from './state/agent.effects';

import { AgentShellComponent } from './containers/agent-shell/agent-shell.component';
import { AgentListComponent } from './components/agent-list/agent-list.component';
import { AgentEditShellComponent } from './containers/agent-edit-shell/agent-edit-shell.component';
import { AgentEditComponent } from './components/agent-edit/agent-edit.component';

// Módulo con elementos compartidos (service, directive, pipes, components, etc.).
import { SharingModule } from '../sharingModule/sharingModule.module';

// Módulo para la ordenación de tablas por columnas.
import { SortableColumnModule } from '../sortableColumn/sortableColumn.module';

@NgModule({
  declarations: [
    AgentShellComponent,
    AgentEditShellComponent,
    AgentListComponent,
    AgentEditComponent
  ],
  imports: [
    SharingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forFeature('agents', reducer),
    EffectsModule.forFeature([AgentEffects]),
    SortableColumnModule
  ],
  exports: [
    AgentListComponent,
    AgentEditComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SortableColumnModule
  ]
})
export class AgentModule {
  constructor(
  ) {}
}
